import { BaseApplication } from 'ohzi-core';
import { CameraManager } from 'ohzi-core';
import { PerspectiveCamera } from 'ohzi-core';
import { Screen } from 'ohzi-core';
import { NormalRender } from 'ohzi-core';
import { Graphics } from 'ohzi-core';
import { ResourceContainer } from 'ohzi-core';
import { OS } from 'ohzi-core';

import CameraController from '/js/components/CameraController/CameraController';
import HomeView from './js/html_components/HomeView';

import { Color } from 'three';

import FloorManager from './js/components/CameraController/FloorManager';
import WallClicker from './js/components/wall_clicker/WallClicker';
import HTMLManager from './js/html_components/HTMLManager';
import FontSizeController from './js/html_components/FontSizeController';
import CompanyView from './js/html_components/CompanyView';
import WallsManagerMobile from './js/components/CameraController/WallsManagerMobile';
import WallsManagerDesktop from './js/components/CameraController/WallsManagerDesktop';
// import DoubleRender from './js/components/DoubleRender';

export default class MainApplication extends BaseApplication
{
  constructor(renderer)
  {
    super();
    this.renderer = renderer;

    this.camera_controller = new CameraController();
    this.normal_render_mode = new NormalRender();
    // this.double_render_mode = new DoubleRender();
    // SceneManager.lights_scene = new Scene();

    // this.camera_zoom = OS.is_mobile ? 30 : 20;
    this.camera_zoom = 20;
  }

  start()
  {
    Graphics.set_state(this.normal_render_mode);

    this.__init_camera();
    this.__init_camera_controller();

    this.config = ResourceContainer.get_resource('config');

    // Debug.draw_axis();
    // SceneManager.current.add(new Grid());

    this.wall_manager = OS.is_mobile ? new WallsManagerMobile() : new WallsManagerDesktop();
    this.floor_manager = new FloorManager();

    this.wall_clicker = new WallClicker(this.camera_controller, this.wall_manager);

    this.home_view = HomeView;
    this.company_view = CompanyView;

    this.wall_manager.start();
    this.floor_manager.start();

    HTMLManager.start(this);
    FontSizeController.start();

    this.home_view.start();
    this.company_view.start(this.wall_manager.hall_size);

    this.camera_controller.set_hall_size(this.wall_manager.hall_size);

    // let ambient_light = new AmbientLight('#ffffff');
    // ambient_light.visible = true;
    // ambient_light.intensity = 4;
    // SceneManager.current.add(ambient_light);
  }

  update()
  {
    this.camera_controller.update();
    this.wall_manager.update();
    this.floor_manager.update();
    this.home_view.update();
    this.company_view.update();
    this.wall_clicker.update();

    HTMLManager.update();
  }

  on_resize()
  {
    FontSizeController.on_resize();
  }

  post_start()
  {
  }

  __init_camera()
  {
    let camera = new PerspectiveCamera(100, Screen.aspect_ratio, 0.1, 2000);
    camera.updateProjectionMatrix();
    // camera.position.z = -10;

    camera.clear_color.copy(new Color('#101010'));
    camera.clear_alpha = 1;
    CameraManager.current = camera;
  }

  __init_camera_controller()
  {
    this.camera_controller.set_camera(CameraManager.current);
    // this.camera_controller.set_idle();
    // this.camera_controller.set_debug_mode();
    this.camera_controller.set_initial_mode(-25);

    this.camera_controller.min_zoom = 1;
    this.camera_controller.max_zoom = 40;
    this.camera_controller.reference_zoom = this.camera_zoom;
    this.camera_controller.reference_position.set(0, 20, -30);
    this.camera_controller.set_rotation(0, 180);
  }
}
